module.exports = __webpack_public_path__ + "static/media/icon-white-red-Report.4921506a.4921506a.svg";